module.exports = __webpack_public_path__ + "aac2addc85886ed6c54b54750c7f42d1.png";